import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import CountUp from "react-countup";
import '../Styles/Home.css';
import Banner from "../assets/pgs_banner.webp"
import { Fade } from "react-awesome-reveal";
import { Slide, Zoom } from 'react-awesome-reveal';
import { motion } from "framer-motion";
import { Helmet } from "react-helmet-async";
// import Footer from "./Footer";



const rotatingWords = ["Data Handling", "Assessment", "Compliance Expertise", "Submission Processing"];

const Home = () => {
  const text1 = "Hire Us".split("");
  const faqs = [
    { question: "What is the ECO4 Grant?", answer: "ECO4 is a UK government scheme providing free energy efficiency improvements for eligible households." },
    { question: "Who is eligible?", answer: "Households with low income, specific property types, or poor energy ratings may qualify." },
    { question: "What upgrades are included?", answer: "Insulation, heating systems, solar panels, smart thermostats, and more." },
    { question: "Does it cost anything?", answer: "No, improvements are 100% funded under the ECO4 scheme." },
    { question: "How do I apply?", answer: "Simply fill out our Free Assessment form and our team will contact you." }
  ];

  const stats = [
    { value: 99, suffix: '%', label: 'Job Satisfaction Ratio', color: 'text-success' },
    { value: 5, suffix: '+', label: 'Years of Experience', color: 'text-primary' },
    { value: 3500, suffix: '+', label: 'Successful Projects', color: 'text-success' },
    { value: 25, suffix: '+', label: 'Experts', color: 'text-warning' },
    { value: 20, suffix: '+', label: 'Global Clients', color: 'text-info' },
  ];

  const [currentWordIndex, setCurrentWordIndex] = useState(0);
  const [fade, setFade] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      setFade(true);
      setTimeout(() => {
        setCurrentWordIndex((prevIndex) => (prevIndex + 1) % rotatingWords.length);
        setFade(false);
      }, 300); // matches fade time
    }, 2000);

    return () => clearInterval(interval);
  }, []);


  return (
    <>
      <Helmet>
        <title>Paramount Green Services Pvt (Ltd) - No.1 Destination for Energy Efficiency</title>
        <meta name="description" content="Free heating, insulation, and solar panel grants across the UK. Transform your home’s energy efficiency today." />
      </Helmet>

      {/* HERO SECTION */}
      {/* <section className="hero d-flex align-items-center text-center text-white">
        <div className="container">
          <h1 className="display-3 fw-bold">Welcome to Energy Solutions</h1>
          <p className="lead mt-3">
            Reliable, affordable, and sustainable energy for your needs.
          </p>
          <button className="btn btn-light btn-lg mt-4">Get Started</button>
        </div>
      </section> */}
      <section className="Hhero-section align-items-center text-white">
        <div className="top-banner text-center py-2">
          <p className="mb-0">✨ Welcome to <span className="animated-gradient"><strong>Paramount Green Services</strong></span> ✨</p>
        </div>

        <div className="container d-flex flex-wrap justify-content-between align-items-center">
          {/* Left Content */}
          <div className="hero-text col-lg-6 col-md-12" style={{ marginTop: "70px" }}>
            <h1 className="hero-title">
              We specialize in creating
              <br />
              <span className="highlighted-word">
              {rotatingWords[currentWordIndex]}
              </span>
            </h1>

            <p className="hero-subtitle">ON-TIME. ON-BUDGET. ON-POINT.</p>

            <div className="mt-4 mb-4">

              <p className="connect-text mb-0">
                Get <strong>Expert Guidance</strong> over a quick call, <br />
                Choose the right partner for sustainable growth and start your project with confidence and clarity. Choose the right partner for sustainable growth and start your project with confidence and clarity.
              </p>
              <p>Empowering you to build a sustainable future — with clarity, confidence, and the right partner by your side. </p>
            </div>
                <button className="btn btn-green">
                <Link to="/contactus/" className="text-decoration-none text-white">Let's Connect <span className="btn-icon">➜</span></Link>
              </button>
            {/* Awards */}
            {/* <div className="awards d-flex gap-4 mt-5">
              <div className="award-item text-center">
                <img src="https://www.pixlogix.com/wp-content/themes/Pixlogix/img/award-bg.svg" alt="Top Developers" />
                <p>TOP DEVELOPERS 2019 & 2022<br /><strong>Clutch</strong></p>
              </div>
              <div className="award-item text-center">
                <img src="https://www.pixlogix.com/wp-content/themes/Pixlogix/img/award-bg.svg" alt="SOTD Award Winner" />
                <p>SOTD AWARD WINNER 2010<br /><strong>awwwards.</strong></p>
              </div>
              <div className="award-item text-center">
                <img src="https://www.pixlogix.com/wp-content/themes/Pixlogix/img/award-bg.svg" alt="Most Promising Company" />
                <p>
                  MOST PROMISING COMPANY 2018<br />
                  <strong>siliconindia</strong>
                </p>
              </div>
            </div> */}
          </div>

          {/* Right Image */}
          <div className="hero-image col-lg-5 col-md-12 text-center ms-3">
            <img src={Banner} alt="Hero Illustration" className="img-fluid" />
            {/* <canvas data-engine="three.js r145" width="832" height="675" style="display: block; width: 925px; height: 751px;"></canvas> */}
          </div>
        </div>
      </section>

      <section className="recognition-section container py-5 d-flex flex-wrap justify-content-between align-items-center">
        {/* Left Content */}
        <div className="col-lg-6 col-md-12 mb-4">
          <small className="section-label">OUR INDUSTRIAL TRUST</small>
          <h2 className="section-title">
            Recognized for <span className="highlight-green">excellence & trust</span>
          </h2>
          <p className="section-description">
            Over the years, Paramount Green Services has earned the trust of clients and recognition across the industry for our commitment to safety, innovation, and customer satisfaction:
          </p>

          <ul className="recognition-list">
            <li>Certified and compliant with international safety and maintenance standards.</li>
            <li>Trusted partner for corporate and private travel services nationwide.</li>
            <li>Recognized for eco-friendly initiatives and sustainable operations.</li>
            <li>High customer retention rate with 24/7 dedicated support.</li>
            <li>Modern fleet equipped with the latest technology for safety & comfort.</li>
            <li>Preferred choice for premium travel experiences in the region.</li>
            <li>Proven track record of reliability and punctuality.</li>
          </ul>


          <button className="btn btn-green mt-3" onClick={() => window.location.href = "/contactus/"}>
            Get in Touch <span className="btn-icon">➜</span>
          </button>
        </div>

        {/* Right Content */}
        <div className="recognition-awards single-award">
          {/* Award Background SVG */}
          <img
            src="https://www.pixlogix.com/wp-content/themes/Pixlogix/img/award-bg.svg"
            alt="Award background"
            className="award-bg"
          />

          {/* Centered Text */}
          <div className="award-text">
            <div><strong>Top Energy Provider</strong></div>
            <div>2019 & 2022</div>
            <div><strong>Green Business Awards</strong></div>
          </div>
        </div>

      </section>
      {/* <section className="container text-white py-5">
      <p className="fs-5">We specialize in creating</p>
      <h1 className="fw-bold display-5">
        Top-notch{" "}
        <span className={`highlighted-word ${fade ? "fade-out" : ""}`}>
  {rotatingWords[currentWordIndex]}
</span>

      </h1>
      <p className="mt-3 fs-6">ON-TIME. ON-BUDGET. ON-POINT.</p>
    </section> */}

      <section className="about-section py-5">
        <div className="container">
          {/* Top Content */}
          <div className="row align-items-center mb-5">
            {/* Text Left */}
            <div className="col-md-6 text-white mb-4 mb-md-0">
              <h2>
                About <span className="text-success fs-2"><Fade>PARAMOUNT GREEN SERVICES</Fade></span>
              </h2>
              <p className="mt-3">
                Paramount Green Services began in 2018 with a simple vision: to provide practical, reliable, and affordable solutions that reduce energy consumption and promote sustainability. We believe that energy efficiency is not just about cutting costs — it’s about building a greener future for generations to come. </p>
              <div class="d-flex flex-wrap gap-3 mt-4">
                <button class="custom-button" onClick={() => window.location.href = "/about-us/"}>
                  Learn More  <span class="icon">➜</span>
                </button>
              </div>
            </div>

            {/* Illustration Right */}
            <div className="col-md-6 text-center">
              <img src="https://www.pixlogix.com/wp-content/uploads/2023/06/about-company.svg" alt="About Illustration" className="img-fluid" style={{ maxHeight: '300px' }} />
            </div>
          </div>

          {/* Stats Section */}
          <div className="row text-center" style={{ justifyContent: 'center', marginTop: '90px' }}>
            {stats.map((stat, index) => (
              <div className="col-6 col-md-4 col-lg-2 mb-4" key={index}>
                <div className="stat-box p-3 rounded h-100">
                  <h3 className={`fw-bold ${stat.color}`}>
                    <CountUp end={stat.value} duration={2.5} suffix={stat.suffix} />
                  </h3>
                  <p className="fw-semibold text-white mt-2 small">{stat.label}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>


      {/* SERVICES */}
      <section className="py-5 bg-white">
        <div className="container text-center">
          <span className="badge bg-light text-primary px-3 py-2 mb-2">Our Services</span>
          <h2 className="fw-bold" style={{ color: "#28a745" }}><Fade>Comprehensive Energy Solutions</Fade></h2>
          <Zoom>
            <p className="text-muted mb-5">
              From insulation to renewable energy, we provide complete energy efficiency solutions backed Under linked by the UK Government's ECO4 scheme.
            </p>
          </Zoom>

          <Fade>
            <div className="row g-4 justify-content-center">
              {/* Submission Administrator */}
              <div className="col-md-5">
                <div className="service-card h-100 p-4 text-start">
                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <div className="icon-box">
                      <i className="bi bi-person-badge-fill"></i>
                    </div>
                    <span className="badge bg-primary-subtle text-primary">Core Service</span>
                  </div>
                  <h5 className="fw-bold">Submission Administrator</h5>
                  <p className="text-muted">
                    Ensuring timely and accurate submissions of all project-related documents.
                  </p>
                  <ul className="list-unstyled mb-4">
                    <li>✅ Document Preparation</li>
                    <li>✅ Accurate Filing</li>
                    <li>✅ Deadline Management</li>
                    <li>✅ Stakeholder Coordination</li>
                  </ul>
                  <div className="star-divider d-flex align-items-center justify-content-center my-3">
                    <span className="star mx-2">★</span>
                    <span className="line"></span>
                    <span className="star mx-2">★</span>
                  </div>

                </div>
              </div>

              {/* Project Handling */}
              <div className="col-md-5">
                <div className="service-card h-100 p-4 text-start">
                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <div className="icon-box">
                      <i className="bi bi-diagram-3-fill text-success"></i>
                    </div>
                    <span className="badge bg-success-subtle text-success">Management</span>
                  </div>
                  <h5 className="fw-bold">Project Handling</h5>
                  <p className="text-muted">
                    Comprehensive project oversight to ensure smooth execution from start to finish.
                  </p>
                  <ul className="list-unstyled mb-4">
                    <li>✅ Task Delegation</li>
                    <li>✅ Progress Monitoring</li>
                    <li>✅ Risk Management</li>
                    <li>✅ Efficient Delivery</li>
                  </ul>
                  <div className="star-divider d-flex align-items-center justify-content-center my-3">
                    <span className="star mx-2">★</span>
                    <span className="line"></span>
                    <span className="star mx-2">★</span>
                  </div>
                </div>
              </div>
            </div>
          </Fade>

          <div className="mb-4 mt-4"></div>

          <Fade>
            <div className="row g-4 justify-content-center">
              {/* Building Layout Expertise */}
              <div className="col-md-5">
                <div className="service-card h-100 p-4 text-start">
                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <div className="icon-box">
                      <i className="bi bi-building-fill"></i>
                    </div>
                    <span className="badge bg-info-subtle text-info">Expertise</span>
                  </div>
                  <h5 className="fw-bold">Building Layout Expertise</h5>
                  <p className="text-muted">
                    Professional planning and layout design tailored for efficiency and safety.
                  </p>
                  <ul className="list-unstyled mb-4">
                    <li>✅ Structural Planning</li>
                    <li>✅ Optimized Layouts</li>
                    <li>✅ Space Utilization</li>
                    <li>✅ Modern Design Standards</li>
                  </ul>
                  <div className="star-divider d-flex align-items-center justify-content-center my-3">
                    <span className="star mx-2">★</span>
                    <span className="line"></span>
                    <span className="star mx-2">★</span>
                  </div>
                </div>
              </div>

              {/* Compliance Expertise */}
              <div className="col-md-5">
                <div className="service-card h-100 p-4 text-start">
                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <div className="icon-box">
                      <i className="bi bi-shield-check text-warning"></i>
                    </div>
                    <span className="badge bg-warning-subtle text-warning">Trusted</span>
                  </div>
                  <h5 className="fw-bold">Compliance Expertise</h5>
                  <p className="text-muted">
                    Ensuring adherence to regulations, legal standards, and safety protocols.
                  </p>
                  <ul className="list-unstyled mb-4">
                    <li>✅ Regulatory Compliance</li>
                    <li>✅ Safety Standards</li>
                    <li>✅ Risk Assessment</li>
                    <li>✅ Legal Documentation</li>
                  </ul>
                  <div className="star-divider d-flex align-items-center justify-content-center my-3">
                    <span className="star mx-2">★</span>
                    <span className="line"></span>
                    <span className="star mx-2">★</span>
                  </div>
                </div>
              </div>
            </div>
          </Fade>

        </div>
      </section>


      {/* GET READY SCHEMES */}
      <section className="py-5">
        <div className="container">
          <h2 className="text-center mb-4 fw-bold" style={{ color: "#28a745" }}>Get Ready Schemes</h2>
          <Zoom>
            <div className="row g-4">
              <div className="col-md-6">
                <div className="p-4 bg-light rounded shadow-sm">
                  <h2 className="fw-bold text-success text-center">
                    ECO4 Scheme
                  </h2>
                  <p className="text-center">Comprehensive support for whole-house energy upgrades.</p>
                  <ul className="list-unstyled mb-0">
                    <li>✅ Loft, wall, & roof insulation upgrades</li>
                    <li>✅ Renewable heating installations (heat pumps, solar)</li>
                    <li>✅ Boiler and heating system upgrades</li>
                    <li>✅ Compliance & certification for energy standards</li>
                  </ul>
                </div>
              </div>
              <div className="col-md-6">
                <div className="p-4 bg-light rounded shadow-sm">
                  <h2 className="fw-bold text-success text-center">
                    GBIS Scheme
                  </h2>
                  <p className="text-center">Single-measure support focused on insulation solutions.</p>
                  <ul className="list-unstyled mb-0">
                    <li>✅ Cavity wall insulation</li>
                    <li>✅ Loft insulation for individual rooms</li>
                    <li>✅ Internal or external wall insulation (single measure)</li>
                    <li>✅ Energy performance assessments & compliance</li>
                  </ul>
                </div>
              </div>
            </div>
          </Zoom>
        </div>
      </section>


      <section className="py-5 bg-light">
        <div className="container text-center">
          {/* Header */}
          <span className="badge bg-success-subtle text-success px-3 py-2 mb-2">
            Government Scheme
          </span>
          <h2 className="fw-bold">
            ECO4 Grant <span className="text-success">Funding</span>
          </h2>
          <Fade>
            <p className="text-muted mb-5">
              The Energy Company Obligation (ECO4) scheme provides free energy efficiency
              improvements for eligible households across England, Wales, and Scotland.
            </p>
          </Fade>

          <div className="row g-4">
            {/* Left Card - What is ECO4 */}
            <div className="col-md-6">
              <Slide direction="left">
                <div className="eco4-card h-100 p-4 text-start">
                  <h5 className="fw-bold mb-3">Landlords Can Benefit Too</h5>
                  <p className="text-muted">
                    The ECO4 and Great British Insulation Scheme (GBIS) aren’t just for homeowners—
                    private rented properties are also eligible. Improve your property’s EPC rating
                    to C or above, stay compliant with regulations, and boost tenant appeal—all at no cost.
                  </p>
                  <ul className="list-unstyled mt-3">
                    <li className="mb-4">✅ <strong>100% Free:</strong> Fully funded by government schemes</li>
                    <li className="mb-4">✅ <strong>Stay Compliant:</strong> Meet EPC and rental regulations</li>
                    <li className="mb-4">✅ <strong>Tenant Appeal:</strong> Lower bills & greener homes</li>
                    <li className="mb-4">✅ <strong>Add Value:</strong> Increase property market value</li>
                    <li className="mb-4">✅ <strong>Nationwide:</strong> Available across England, Wales & Scotland</li>
                    <li className="mb-0">✅ <strong>Future Proof:</strong> Long-term savings & sustainability</li>
                  </ul>

                </div>
              </Slide>
            </div>


            {/* Right Card - Eligibility */}

            <div className="col-md-6">
              <Slide direction="right">
                <div className="eco4-card h-100 p-4 d-flex flex-column text-start">
                  <h5 className="fw-bold mb-3 text-success">Eligibility Criteria</h5>
                  <p className="text-muted">
                    Check if you qualify for free energy efficiency improvements under the ECO4 scheme.
                  </p>

                  <div className="criteria-list flex-grow-1">
                    <div className="criteria-item d-flex align-items-start mb-3">
                      <i className="bi bi-wallet2 text-success me-2 fs-5"></i>
                      <div>
                        <strong>Household Income</strong>
                        <p className="mb-0 text-muted small">Benefits recipients or low household income</p>
                      </div>
                    </div>

                    <div className="criteria-item d-flex align-items-start mb-3">
                      <i className="bi bi-house-fill text-success me-2 fs-5"></i>
                      <div>
                        <strong>Property Type</strong>
                        <p className="mb-0 text-muted small">Owner-occupied or private rented properties</p>
                      </div>
                    </div>

                    <div className="criteria-item d-flex align-items-start mb-3">
                      <i className="bi bi-lightning-fill text-success me-2 fs-5"></i>
                      <div>
                        <strong>Energy Rating</strong>
                        <p className="mb-0 text-muted small">Properties with EPC rating D, E, F, or G</p>
                      </div>
                    </div>

                    <div className="criteria-item d-flex align-items-start">
                      <i className="bi bi-calendar-check text-success me-2 fs-5"></i>
                      <div>
                        <strong>Property Age</strong>
                        <p className="mb-0 text-muted small">Built before 2012 or specific construction types</p>
                      </div>
                    </div>
                  </div>

                  {/* Button at the bottom */}
                  <div className="mt-4">
                    <a href="/who-qualifies/" className="btn btn-success w-100">
                      Check Who Qualifies
                    </a>
                  </div>
                </div>
              </Slide>
            </div>


          </div>

        </div>
      </section>


      {/* WHAT'S INCLUDED */}
      <Zoom>
        <section className="py-5 bg-light">
          <div className="container">
            <div className="eco4-box p-5 text-center">
              <h2 className="fw-bold mb-3">What's Included in the ECO4 Grant?</h2>
              <p className="text-muted mb-5">
                Comprehensive energy efficiency improvements that can transform your home's
                performance and reduce your bills.
              </p>

              <div className="row g-4 text-start">
                <div className="col-md-6">
                  <div className="eco4-item">✅ Up to £10,000 in energy efficiency improvements</div>
                </div>
                <div className="col-md-6">
                  <div className="eco4-item">✅ 100% funded installations with no upfront costs</div>
                </div>
                <div className="col-md-6">
                  <div className="eco4-item">✅ Loft and wall insulation systems</div>
                </div>
                <div className="col-md-6">
                  <div className="eco4-item">✅ Air source heat pump installations</div>
                </div>
                <div className="col-md-6">
                  <div className="eco4-item">✅ Solar panel and battery storage systems</div>
                </div>
                <div className="col-md-6">
                  <div className="eco4-item">✅ Modern boiler replacements</div>
                </div>
                <div className="col-md-6">
                  <div className="eco4-item">✅ Smart heating controls and thermostats</div>
                </div>
                <div className="col-md-6">
                  <div className="eco4-item">✅ Professional assessment and ongoing support</div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </Zoom>

      {/* CHECK ELIGIBILITY */}
      <section className="hire-section py-5">
        <div className="container text-white">
          <div className="row align-items-center">
            {/* Left Side */}
            <div className="col-md-4 mb-4 mb-md-0 text-center text-md-start">
              <p className="text-success fw-bold small">WHAT WE DO</p>
              <h2 className="fw-bold"><motion.h2
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.6 }} // 👈 triggers when 60% visible
                className="heading"
              >
                {text1.map((char, index) => (
                  <motion.span
                    key={index}
                    variants={{
                      hidden: { opacity: 0, y: 20 },
                      visible: { opacity: 1, y: 0 },
                    }}
                    transition={{ delay: index * 0.05 }}
                  >
                    {char}
                  </motion.span>
                ))}
              </motion.h2></h2>
              <p>
                Our team of experienced professionals is ready to join your project on a full-time, part-time, or hourly basis. Take advantage of our expertise and hire the best talent through us!
              </p>
              <div class="d-flex flex-wrap gap-3 mt-4">
                <button class="custom-button">
                  <Link className="text-decoration-none text-white">Get A Query <span className="icon mx-2">➜</span></Link>
                </button>
              </div>

            </div>

            {/* Frontend Card */}
            <div className="col-md-4 mb-4 mb-md-0">
              <div className="developer-card frontend-card p-4 rounded text-white">
                <h5 className="fw-light">Project</h5>
                <h4 className="fw-bold">MANAGMENT</h4>
                <ul className="list-unstyled mt-3">
                  <li>•  Submission Administration</li>
                  <li>• Project Handling & Coordination</li>
                  <li>• Building Layout Expertise</li>
                  <li>• Compliance & Regulations</li>
                </ul>
              </div>
            </div>

            {/* Backend Card */}
            <div className="col-md-4">
              <div className="developer-card backend-card p-4 rounded text-white">
                <h5 className="fw-light">Specialist</h5>
                <h4 className="fw-bold">SUPPORT</h4>
                <ul className="list-unstyled mt-3">
                  <li>• Strategic Planning & Guidance</li>
                  <li>• Energy & Sustainability Solutions</li>
                  <li>• On-site Supervision</li>
                  <li>• Ongoing Compliance Support</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="py-5 text-center text-white">
        <div className="container">
          <h2 className="fw-bold mb-3 text-success">Check Your Eligibility Today</h2>
          <p className="mb-4 text-black">
            Find out what grants you qualify for and start saving on your energy bills immediately.
          </p>

          <div className="d-flex justify-content-center gap-3 flex-wrap mb-3">
            <Link to="/who-qualifies/" className="btn btn-lg eco4-btn-primary">Free Eligibility Check</Link>
            <Link to="/Contactus" className="btn btn-lg eco4-btn-secondary">Speak to an Expert</Link>
          </div>

          <p className="small mb-0">
            ✓ No obligation assessment &nbsp; ✓ Professional advice &nbsp; ✓ Fast approval process
          </p>
        </div>
      </section>


    </>
  );
};

export default Home;
